export default __webpack_public_path__ + "static/media/Legacy.4c47bd59.png";